<template>

    <footer class="footer-wrapper">

        <div class="container">

            <div class="footer-inner">

                <div class="footer-copy">
                    &copy; {{ year }} WIESNERD Daniel Wiesner
                    <span class="divider">|</span>
                    <a href="/impressum">Impressum</a>
                    <span class="divider">|</span>
                    <a href="/datenschutz">Datenschutz</a>
                </div>

            </div>

        </div>

    </footer>

</template>

<script>

    export default {

        name: 'TheFooterComponent',

        computed: {

            year() {

                return new Date().getFullYear()

            },

        },

    }

</script>

<style scoped>

    .footer-wrapper {

        background-color: #0d1f3c;
        padding: 2rem 0;
        margin-top: 1rem;

    }

    .footer-inner {

        display: flex;
        justify-content: center;

    }

    .footer-copy {

        display: flex;
        align-items: center;
        gap: 0.6rem;
        color: rgba(255, 255, 255, 0.4);
        font-size: 0.8rem;

    }

    .footer-copy a {

        color: rgba(255, 255, 255, 0.6);
        text-decoration: none;
        transition: color 0.2s ease;

    }

    .footer-copy a:hover {

        color: #ffffff;

    }

    .divider {

        color: rgba(255, 255, 255, 0.2);

    }

</style>
